// extracted by mini-css-extract-plugin
export default {"mmsiCount":"VesselsCount_mmsiCount__ZjHmy"};